module.exports = __webpack_public_path__ + "static/baguio01-bebff07117e8787a99b662247868b852.jpg";